import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InfluencerUpgradeFormEnum } from "./config";
import { Form, Input, Radio } from "antd";
import { DeleteIcon, PlusIcon } from "../icons";

export default function InfluencerUpgradeForm({
  value,
  onChange,
  isPreview = false,
  listValue = [],
}: {
  value: InfluencerUpgradeFormEnum;
  onChange?: any;
  isPreview?: boolean;
  listValue?: any[];
}) {
  const { t } = useTranslation();
  // 达人会员升级
  const [creatorAccountNeeded, setCreatorAccountNeeded] = useState<any>(null);
  useEffect(() => {
    setCreatorAccountNeeded(
      value || InfluencerUpgradeFormEnum.NO_ACCESS_NEEDED
    );
  }, [value]);

  return (
    <div className="mt-6">
      <div className="self-stretch justify-start text-font&icon-primary text-base font-semibold font-['DM_Sans'] leading-6">
        {t("components.influencerUpgradeForm.title")}
      </div>
      <div className="flex items-center mt-3 gap-6">
        {isPreview ? (
          <Radio.Group
            value={creatorAccountNeeded}
            onChange={(e) => {
              const newValue = e.target.value as InfluencerUpgradeFormEnum;
              setCreatorAccountNeeded(newValue);
              onChange && onChange(newValue);
            }}
            disabled={true}
          >
            <Radio value={InfluencerUpgradeFormEnum.ENABLE_ACCESS_ADD_CREDITS}>
              {t("components.influencerUpgradeForm.enableAccessAddCredits")}
            </Radio>
            <Radio value={InfluencerUpgradeFormEnum.NO_ACCESS_NEEDED}>
              {t("components.influencerUpgradeForm.noAccessNeeded")}
            </Radio>
          </Radio.Group>
        ) : (
          <Form.Item
            name="creatorAccountNeeded"
            rules={[
              {
                required: true,
                message: t(
                  "components.influencerUpgradeForm.validationMessage"
                ),
              },
            ]}
            className="mb-0"
            initialValue={InfluencerUpgradeFormEnum.NO_ACCESS_NEEDED}
          >
            <Radio.Group
              value={creatorAccountNeeded}
              onChange={(e) => {
                const newValue = e.target.value as InfluencerUpgradeFormEnum;
                setCreatorAccountNeeded(newValue);
                onChange && onChange(newValue);
              }}
              disabled={isPreview}
            >
              <Radio
                value={InfluencerUpgradeFormEnum.ENABLE_ACCESS_ADD_CREDITS}
              >
                {t("components.influencerUpgradeForm.enableAccessAddCredits")}
              </Radio>
              <Radio value={InfluencerUpgradeFormEnum.NO_ACCESS_NEEDED}>
                {t("components.influencerUpgradeForm.noAccessNeeded")}
              </Radio>
            </Radio.Group>
          </Form.Item>
        )}
      </div>
      {creatorAccountNeeded ===
        InfluencerUpgradeFormEnum.ENABLE_ACCESS_ADD_CREDITS && (
        <div className="bg-[#FAFAF9] rounded-[16px] p-6 mt-3">
          <div className="w-full">
            {isPreview ? (
              // 预览模式：直接渲染 listValue
              listValue && listValue.length > 0 ? (
                <div className="flex flex-col gap-2">
                  {listValue.map((item: any, index: number) => (
                    <div key={index} className="w-full flex flex-col gap-2">
                      <div className="flex items-center gap-4">
                        <div className="flex flex-col justify-start items-start gap-1 w-[290px]">
                          <div className="self-stretch justify-start">
                            <span className="text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
                              {t(
                                "components.influencerUpgradeForm.informationRequiredLabel"
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="flex-1 justify-start text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
                          {t(
                            "components.influencerUpgradeForm.instructionLabel"
                          )}
                        </div>
                      </div>
                      <div className="flex items-start gap-4">
                        <div className="w-[290px]">
                          <div className="justify-start text-text-color-primary text-sm font-medium font-['Inter']">
                            {item.field}
                          </div>
                        </div>
                        <div className="flex-1">
                          <div className="self-stretch justify-start text-font&icon-primary text-sm font-medium font-['Inter']">
                            {item.description}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null
            ) : (
              // 编辑模式：使用 Form.List
              <Form.List
                name="creatorAccountInfoFields"
                initialValue={
                  listValue && listValue.length > 0
                    ? listValue
                    : [{ field: "", description: "" }]
                }
              >
                {(fields, { add, remove }) => (
                  <div className="flex flex-col gap-2">
                    {fields.map((field: any, index) => (
                      <div
                        key={field.key}
                        className="w-full flex flex-col gap-2"
                      >
                        <div className="flex items-center gap-4">
                          <div className="flex flex-col justify-start items-start gap-1 w-[290px]">
                            <div className="self-stretch justify-start">
                              <span className="text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
                                {t(
                                  "components.influencerUpgradeForm.informationRequiredLabel"
                                )}
                              </span>
                              <span className="text-[#DC2626] text-xs font-medium font-['DM_Sans'] leading-4">
                                *
                              </span>
                            </div>
                          </div>
                          <div className="flex-1 justify-start text-font&icon-secondary text-xs font-medium font-['DM_Sans'] leading-4">
                            {t(
                              "components.influencerUpgradeForm.instructionLabel"
                            )}
                          </div>
                        </div>
                        <div className="flex items-start gap-4">
                          <div className="w-[290px]">
                            <Form.Item
                              name={[field.name, "field"]}
                              rules={[
                                {
                                  required: true,
                                  message: t(
                                    "components.influencerUpgradeForm.informationRequiredValidation"
                                  ),
                                },
                              ]}
                            >
                              <Input
                                placeholder={t(
                                  "components.influencerUpgradeForm.informationRequiredPlaceholder"
                                )}
                                size="large"
                              />
                            </Form.Item>
                          </div>
                          <div className="flex-1">
                            <Form.Item name={[field.name, "description"]}>
                              <Input
                                placeholder={t(
                                  "components.influencerUpgradeForm.instructionPlaceholder"
                                )}
                                size="large"
                              />
                            </Form.Item>
                          </div>
                          {fields.length > 1 && (
                            <span
                              className="cursor-pointer w-[32px] h-[40px] flex justify-center items-center"
                              onClick={() => remove(field.name)}
                            >
                              <DeleteIcon className="delete" />
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                    <Form.Item className="mb-0">
                      <div
                        className="flex items-center text-primary cursor-pointer"
                        onClick={() => add("")}
                      >
                        <PlusIcon className="text-primary" />
                        <span>{t("components.coreAudiencesForm.add")}</span>
                      </div>
                    </Form.Item>
                  </div>
                )}
              </Form.List>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
